/**
 * product-video-autoplay.js
 *
 * On product/featured-product pages, the Vue gallery renders native-video
 * slides as `preview image + play button` and only mounts the actual <video>
 * (wrapped in Plyr) when the user clicks the play button. We want native
 * videos to autoplay muted/looped on page load with no user gesture, so we
 * synthesize that click here.
 *
 * The video element output by `media | video_tag` already carries
 * autoplay/loop/muted/playsinline (see snippets/product-media-templates.liquid),
 * so once Plyr mounts, playback starts on its own. Plyr's control UI is
 * hidden via CSS scoped to .product-single__media__wrapper--video.
 *
 * Only native `video` media is auto-activated. external_video (YouTube/
 * Vimeo) and `model` still require an explicit user gesture.
 */
(function () {
  'use strict';

  var MAX_ATTEMPTS = 30;
  var INTERVAL_MS = 100;

  function findVideoMediaIds() {
    var ids = [];
    var templates = document.querySelectorAll('template[id^="media-template-"]');
    for (var i = 0; i < templates.length; i++) {
      var t = templates[i];
      if (!t.content) continue;
      var el = t.content.querySelector('[data-media-type="video"]');
      if (el && el.dataset && el.dataset.mediaId) {
        ids.push(el.dataset.mediaId);
      }
    }
    return ids;
  }

  function activate(ids) {
    var clicked = 0;
    ids.forEach(function (mediaId) {
      var btn = document.querySelector(
        '.product-medias__icon[data-media-id="' + mediaId + '"]'
      );
      if (btn && !btn.dataset.autoActivated) {
        btn.dataset.autoActivated = 'true';
        btn.click();
        clicked++;
      }
    });
    return clicked;
  }

  function attempt(state) {
    var ids = findVideoMediaIds();
    if (ids.length === 0) {
      // No video media on this page — nothing to do.
      return;
    }
    // Wait until Vue has rendered the play-button overlays for those media.
    var btnCount = document.querySelectorAll(
      '.product-medias__icon[data-media-id]'
    ).length;
    if (btnCount === 0) {
      if (++state.tries < MAX_ATTEMPTS) {
        setTimeout(function () { attempt(state); }, INTERVAL_MS);
      }
      return;
    }
    activate(ids);
  }

  function start() {
    attempt({ tries: 0 });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
